import { ChangeDetectionStrategy, Component, inject, input, OnInit } from '@angular/core';
import { ReactiveFormsModule, UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';
import { NODE_EDIT_TAB_COMPONENT, NodeEditTab, SelectedNodeForEdit } from 'src/app/shared/flow-chart/flow-chart.model';
import { WaitNodeData } from '../../../node-edit.type';

@Component({
  selector: 'edit-wait',
  imports: [
    ReactiveFormsModule,
    TranslatePipe,
  ],
  templateUrl: './edit-wait.component.html',
  styleUrl: './edit-wait.component.scss',
  providers: [
    {
      provide: NODE_EDIT_TAB_COMPONENT,
      useExisting: EditWaitComponent,
    },
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class EditWaitComponent implements OnInit, NodeEditTab {
  public selectedNodeForEdit = input<SelectedNodeForEdit<WaitNodeData>>();
  public disableForm = input<boolean>(false);

  private readonly fb = inject(UntypedFormBuilder);
  private readonly translateService = inject(TranslateService);

  public form: UntypedFormGroup = this.fb.group({
    name: [this.translateService.instant('FLOW_CHART.NODES.WAIT.NAME'), [Validators.required]],
    seconds: [null, [Validators.required]],
  })

  public ngOnInit(): void {
    if (this.disableForm()) {
      this.form.disable();
    }

    if (this.selectedNodeForEdit()?.data?.name) {
      this.form.setValue({
        name: this.selectedNodeForEdit().data.name,
        seconds: this.selectedNodeForEdit().data.seconds ?? null,
      })
    }
  }
}
